import { PasswordValidator } from './passwordValidator';
import { NgModule } from '@angular/core';

@NgModule({
  imports: [],
  exports: [[PasswordValidator]],
  declarations: [PasswordValidator],
  providers: []
})
export class PasswordValidatorModule {}
